var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpacesToolbarFavorite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{opacity:0.8;fill:#FFFFFF;enable-background:new    ;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M12,1.9c0.1,0,0.2,0,0.2,0.1L14,7.5C14.4,8.4,15.2,9,16.2,9h5c0.2,0,0.2,0.1,0.2,0.1c0,0.1,0,0.1-0.1,0.2l0,0  l0,0l-3.8,3.3c-0.8,0.6-1.1,1.6-0.8,2.5l1.9,5.4c0,0.1,0,0.1,0,0.1c0,0.1-0.1,0.1-0.2,0.1s-0.1,0-0.2-0.1l-4.9-3.4  c-0.4-0.3-0.8-0.4-1.3-0.4s-0.9,0.1-1.3,0.4l-4.9,3.4H5.7c-0.1,0-0.2-0.1-0.2-0.1v-0.1L7.4,15c0.3-0.9,0-1.9-0.8-2.5L2.7,9.4  C2.6,9.3,2.6,9.1,2.6,9.1C2.6,9,2.7,9,2.8,9l0,0h5c1,0,1.8-0.6,2.1-1.5L11.7,2C11.8,2,11.9,1.9,12,1.9 M12,0.9c-0.5,0-1,0.3-1.2,0.8  L9,7.2C8.8,7.7,8.4,8,7.8,8l0,0h-5l0,0c-1.2,0-1.7,1.3-0.7,2.1L6,13.5c0.4,0.3,0.6,0.8,0.5,1.3l-1.9,5.4C4.3,21,5,21.8,5.8,21.8  c0.2,0,0.5-0.1,0.7-0.2l4.9-3.4c0.2-0.2,0.5-0.2,0.7-0.2c0.3,0,0.5,0.1,0.7,0.2l4.9,3.4c0.2,0.2,0.5,0.2,0.7,0.2  c0.8,0,1.5-0.7,1.2-1.6l-1.9-5.4c-0.2-0.5,0-1,0.5-1.3l3.9-3.3C22.9,9.4,22.4,8,21.2,8l0,0h-5l0,0c-0.5,0-1-0.3-1.2-0.8l-1.8-5.5  C13,1.2,12.5,0.9,12,0.9L12,0.9z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpacesToolbarFavorite);
export default __webpack_public_path__ + "static/media/spaces_toolbar_favorite.08cdd2ca58c3ade7a4a558ab2a234e7c.svg";
export { ForwardRef as ReactComponent };